import UnAuthorizationModal from './UnAuthorizationModal';

export default UnAuthorizationModal;
